import { Button } from '@/components/ui/button';
import { MapPin, ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-blue-50 px-6">
      <div className="max-w-md w-full text-center space-y-6 animate-in fade-in slide-in-from-bottom-8 duration-700">

        {/* Icon */}
        <div className="flex justify-center">
          <div className="rounded-full bg-blue-100 p-4">
            <MapPin className="h-10 w-10 text-blue-600" />
          </div>
        </div>

        {/* Text */}
        <div className="space-y-3">
          <h1 className="text-7xl font-extrabold text-blue-600 tracking-tight">
            404
          </h1>
          <h2 className="text-2xl font-semibold text-gray-800">
            Page Not Found
          </h2>
          <p className="text-muted-foreground">
            The page you’re looking for doesn’t exist or was moved.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={() => navigate('/')} className="gap-2">
            <Home className="h-4 w-4" />
            Go Home
          </Button>

          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Go Back
          </Button>
        </div>

        {/* Footer hint */}
        <p className="text-xs text-gray-400 pt-4">
          Street Issue Reporter • Civic Tech Platform
        </p>
      </div>
    </div>
  );
}
